<template>
  <b-form>
    <div class="row">
      <div class="col-12">
        <legend class="text-black fw-bold">Identitas KKPRL</legend>
      </div>

      <div class="col-md-6 mb-3">
        <label for="nomor_kkprl">Nomor KKPRL <span class="text-danger">*</span></label>
        <i
          v-if="showKkprlSearch && !readOnly"
          class="fa fa-info-circle ml-1"
          v-b-tooltip.hover.topright="'Mohon input secara manual apabila Nomor KKPRL/OSS belum tersedia di dalam sistem'"
        />
        <div class="d-flex">
          <b-form-input id="nomor_kkprl" v-model="form.nomor_kkprl" :disabled="readOnly" v-validate="'required'" name="Nomor KKPRL" />
          <b-button
            v-if="showKkprlSearch && !readOnly"
            type="button"
            class="ms-2"
            variant="secondary"
            aria-label="Cari Nomor KKPRL"
            :disabled="!form.nomor_kkprl.trim() || isSearchingKkprl"
            @click="$emit('search-kkprl', form.nomor_kkprl.trim())"
          >
            <i class="fa fa-search" />
          </b-button>
        </div>
        <span v-if="errors.has('Nomor KKPRL')" class="text-danger">{{ errors.first('Nomor KKPRL') }}</span>
      </div>

      <div class="col-md-6 mb-3">
        <label for="jenis_kegiatan">Jenis Kegiatan <span class="text-danger">*</span></label>
        <v-select
          input-id="jenis_kegiatan"
          v-model="form.jenis_kegiatan"
          :disabled="readOnly"
          :options="['Berusaha', 'Non Berusaha']"
          v-validate="'required'"
          name="Jenis Kegiatan"
        />
        <span v-if="errors.has('Jenis Kegiatan')" class="text-danger">
          {{ errors.first('Jenis Kegiatan') }}
        </span>
      </div>

      <div class="col-md-6 mb-3">
        <label for="nama_pemegang">Nama Pemegang <span class="text-danger">*</span></label>
        <b-form-input id="nama_pemegang" v-model="form.nama_pemegang" :disabled="readOnly" v-validate="'required'" name="Nama Pemegang" />
        <span v-if="errors.has('Nama Pemegang')" class="text-danger">{{ errors.first('Nama Pemegang') }}</span>
      </div>

      <div class="col-md-6 mb-3">
        <label for="npwp">NPWP <span class="text-danger">*</span></label>
        <b-form-input id="npwp" v-model="form.npwp" :disabled="readOnly" v-validate="'required'" name="NPWP" v-mask="'##.###.###.#-###.####'" />
        <span v-if="errors.has('NPWP')" class="text-danger">{{ errors.first('NPWP') }}</span>
      </div>

      <div v-if="form.jenis_kegiatan === 'Berusaha'" class="col-md-6 mb-3">
        <label for="nib">NIB <span class="text-danger">*</span></label>
        <b-form-input id="nib" v-model="form.nib" :disabled="readOnly" v-validate="'required'" name="NIB" />
        <span v-if="errors.has('NIB')" class="text-danger">{{ errors.first('NIB') }}</span>
      </div>

      <div class="col-md-6 mb-3">
        <label>Provinsi <span class="text-danger">*</span></label>
        <v-select
          v-model="form.provinsi"
          :disabled="readOnly"
          :options="provinsiOptions"
          :reduce="(data) => data.nama_provinsi"
          label="nama_provinsi"
          multiple
          v-validate="'required'"
          name="Provinsi"
        />
        <span v-if="errors.has('Provinsi')" class="text-danger">{{ errors.first('Provinsi') }}</span>
      </div>

      <div class="col-md-6 mb-3">
        <label for="tanggal_terbit">Tanggal Terbit <span class="text-danger">*</span></label>
        <b-form-input id="tanggal_terbit" v-model="form.tanggal_terbit" :disabled="readOnly" type="date" v-validate="'required'" name="Tanggal Terbit" />
        <span v-if="errors.has('Tanggal Terbit')" class="text-danger">{{ errors.first('Tanggal Terbit') }}</span>
      </div>

      <div class="col-12 mt-4">
        <legend class="text-black fw-bold">Rencana Aksi</legend>
      </div>

      <div class="col-md-6 mb-3">
        <label>Jenis Rencana Aksi <span class="text-danger">*</span></label>
        <v-select v-model="form.jenis_rencana_aksi" :disabled="readOnly" :options="['Pertama', 'Lanjutan']" v-validate="'required'" name="Jenis Rencana Aksi" />
        <span v-if="errors.has('Jenis Rencana Aksi')" class="text-danger">{{ errors.first('Jenis Rencana Aksi') }}</span>
      </div>

      <div class="col-md-6 mb-3">
        <label>Metode Penilaian Pelaksanaan <span class="text-danger">*</span></label>
        <v-select v-model="form.metode_penilaian_pelaksanaan" :disabled="readOnly" :options="['Lapangan', 'Terpusat']" v-validate="'required'" name="Metode Penilaian Pelaksanaan" />
        <span v-if="errors.has('Metode Penilaian Pelaksanaan')" class="text-danger">{{ errors.first('Metode Penilaian Pelaksanaan') }}</span>
      </div>

      <div class="col-md-6 mb-3">
        <label>Prioritas <span class="text-danger">*</span></label>
        <v-select v-model="form.prioritas" :disabled="readOnly" :options="['Ya', 'Tidak']" v-validate="'required'" name="Prioritas" />
        <span v-if="errors.has('Prioritas')" class="text-danger">{{ errors.first('Prioritas') }}</span>
      </div>

      <div class="col-md-6 mb-3">
        <label for="tanggal_penilaian">Tanggal Penilaian <span class="text-danger">*</span></label>
        <b-form-input
          id="tanggal_penilaian"
          v-model="form.tanggal_penilaian"
          :disabled="readOnly"
          type="date"
          v-validate="'required'"
          name="Tanggal Penilaian"
        />
        <span v-if="errors.has('Tanggal Penilaian')" class="text-danger">
          {{ errors.first('Tanggal Penilaian') }}
        </span>
      </div>

      <div class="col-md-6 mb-3">
        <label for="lokasi_penilaian">Lokasi Penilaian <span class="text-danger">*</span></label>
        <b-form-input id="lokasi_penilaian" v-model="form.lokasi_penilaian" :disabled="readOnly" v-validate="'required'" name="Lokasi Penilaian" />
        <span v-if="errors.has('Lokasi Penilaian')" class="text-danger">{{ errors.first('Lokasi Penilaian') }}</span>
      </div>

      <div class="col-md-6 mb-3">
        <label>Tim Penilai <span class="text-danger">*</span></label>
        <v-select
          v-model="form.tim_penilai"
          :disabled="readOnly"
          :options="timPenilaiOptions"
          :reduce="(data) => data.id"
          label="nama"
          multiple
          v-validate="'required'"
          name="Tim Penilai"
        />
        <span v-if="errors.has('Tim Penilai')" class="text-danger">{{ errors.first('Tim Penilai') }}</span>
      </div>
    </div>
  </b-form>
</template>

<script>
import axios from 'axios'
import vSelect from 'vue-select'

export default {
  components: { vSelect },
  props: {
    readOnly: { type: Boolean, default: false },
    initialData: { type: Object, default: null },
    showKkprlSearch: { type: Boolean, default: false },
    isSearchingKkprl: { type: Boolean, default: false },
  },
  data() {
    return {
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      user: JSON.parse(localStorage.getItem('userPengendalian')),
      form: {
        nomor_kkprl: '',
        jenis_kegiatan: null,
        npwp: '',
        nama_pemegang: '',
        nib: '',
        provinsi: null,
        tanggal_terbit: '',
        jenis_rencana_aksi: null,
        metode_penilaian_pelaksanaan: null,
        prioritas: null,
        tanggal_penilaian: '',
        lokasi_penilaian: '',
        tim_penilai: [],
      },
      timPenilaiOptions: [],
      provinsiOptions: [],
    }
  },
  async mounted() {
    if (this.initialData) {
      const data = this.initialData
      this.form = {
        ...this.form,
        nomor_kkprl: data.nomor_kkprl || '',
        jenis_kegiatan: data.jenis_kegiatan || null,
        npwp: data.npwp || '',
        nama_pemegang: data.nama_pemegang || '',
        nib: data.nib || '',
        provinsi: data.provinsi || [],
        tanggal_terbit: data.tanggal_terbit || '',
        jenis_rencana_aksi: data.jenis || null,
        metode_penilaian_pelaksanaan: data.metode || null,
        prioritas: data.prioritas || null,
        tanggal_penilaian: data.tanggal_penilaian || '',
        lokasi_penilaian: data.lokasi_penilaian || '',
        tim_penilai: data.tim_penilai || [],
      }
    }
    await Promise.all([this.getTimPenilai(), this.getProvinsi()])
    if (this.initialData) {
      this.form.provinsi.forEach((nama) => {
        if (!this.provinsiOptions.some(option => option.nama_provinsi === nama)) {
          this.provinsiOptions.push({ nama_provinsi: nama })
        }
      })
      this.form.tim_penilai.forEach((id) => {
        if (!this.timPenilaiOptions.some(option => option.id === id)) {
          this.timPenilaiOptions.push({ id, nama: `Tim Penilai ${id}` })
        }
      })
    }
  },
  watch: {
    'form.jenis_kegiatan'(jenisKegiatan) {
      if (this.readOnly) return
      if (jenisKegiatan !== 'Berusaha') {
        this.form.nib = ''
        this.errors.remove('NIB')
      }
    },
  },
  methods: {
    async validateForm() {
      return (await this.$validator.validateAll()) && !this.errors.any()
    },
    applyKkprlData(data) {
      if (this.readOnly) return

      const jenisKegiatan = data.jenis_kegiatan
      this.form.jenis_kegiatan = ['Berusaha', 'Non Berusaha'].includes(jenisKegiatan)
        ? jenisKegiatan
        : null

      const provinsi = Array.isArray(data.provinsi) ? data.provinsi : data.provinsi ? [data.provinsi] : []
      provinsi.forEach((nama) => {
        if (!this.provinsiOptions.some(option => option.nama_provinsi === nama)) {
          this.provinsiOptions.push({ nama_provinsi: nama })
        }
      })
      this.form.nama_pemegang = data.nama_pemegang || ''
      this.form.npwp = data.npwp || ''
      this.form.nib = this.form.jenis_kegiatan === 'Berusaha' ? data.nib || '' : ''
      this.form.provinsi = provinsi
      this.form.tanggal_terbit = data.tanggal_penerbitan || ''
    },
    getFormData() {
      return { ...this.form, tim_penilai: [...this.form.tim_penilai] }
    },
    async getTimPenilai() {
      const res = await axios.get(
        this.baseapiPengendalian + 'api/user?filter=roles,contains,Verifikator;nama_upt,!=,PUSAT&limit=0',
        this.getApiOption(),
      )
      this.timPenilaiOptions = res.data.data
    },
    async getProvinsi() {
      const res = await axios.get(this.baseapiPengendalian + 'api/provinsi?sort=id,ASC&limit=0', this.getApiOption())
      this.provinsiOptions = res.data.data
    },
    getApiOption(option = {}) {
      return {
        headers: { Authorization: `Bearer ${this.user.accessToken}` },
        ...option,
      }
    },
  },
}
</script>
